import { createAsyncThunk } from '@reduxjs/toolkit';

import { APIForeignSystemsGet } from './ForeignSystems.api';

export const fetchForeignSystems = createAsyncThunk('foreignSystems/fetch', async () => {
    const response = await APIForeignSystemsGet();
    return response.data;
});
